import React from 'react';
import { FiltersProvider } from "../../../../../components/providers/FiltersProvider";
import ClientCalls from "./ClientCalls";
import ClientProfileLayout from "../../ClientProfileLayout";

interface ClientCallsListWrapperProps { }

const ClientCallsListWrapper: React.FC<ClientCallsListWrapperProps> = () => {

    return (
        <FiltersProvider>
            <ClientProfileLayout>
                <ClientCalls />
            </ClientProfileLayout>
        </FiltersProvider>
    );
}

export default ClientCallsListWrapper;